module.exports = __webpack_public_path__ + "img/6.788f40bb.png";